// extracted by mini-css-extract-plugin
module.exports = {"alert-msg":"snackbar_alert-msg__J1tUu","alert-title":"snackbar_alert-title__DkXYj"};